import { render } from "./VendorOrdersShowCardShipping.vue?vue&type=template&id=0f1e752e"
import script from "./VendorOrdersShowCardShipping.vue?vue&type=script&lang=js"
export * from "./VendorOrdersShowCardShipping.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__